<template>
  <div>
    <vue-read-progress height="2px"></vue-read-progress>
    <el-container>
      <el-header>
        <router-view name="header" />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer height="100%">
        <router-view name="footer" />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import * as types from './store/types'
import VueReadProgress from 'vue-read-progress'

export default {
  name: 'App',
  components: {
    VueReadProgress
  },
  methods: {
    initData () {
      this.$store.dispatch(types.SETTINGS_INIT_DATA)
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style>
body {
  margin: 0px;
  background-color: #e9eef3;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-container {
  background-color: #e9eef3;
  margin-bottom: 60px;
}

.el-header {
  position: fixed;
  background: #fff;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
  z-index: 1;
  width: 100%;
  height: 80px;
  text-align: center;
}

.el-main {
  margin: 0 auto;
  width: 100%;
  max-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue